import { render, staticRenderFns } from "./ContentMessage.vue?vue&type=template&id=35bc09a6&scoped=true"
import script from "./ContentMessage.vue?vue&type=script&lang=js"
export * from "./ContentMessage.vue?vue&type=script&lang=js"
import style0 from "./ContentMessage.vue?vue&type=style&index=0&id=35bc09a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc09a6",
  null
  
)

export default component.exports